import React, { useContext, useState } from "react";
import { Fade } from "react-bootstrap";
import Sidebar from "../components/sidebar/Sidebar";
import PostDetails from "../components/postDetails/PostDetails";
import PostList from "../components/postList/PostList";
import Footer from "../components/footer/Footer";
import { ContentContext } from "../components/content/ContentContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import FilterProvider from "../components/filterContext/FilterContext";

const Forum = () => {
  const { content, selectedPostId } = useContext(ContentContext);
  const [searchQuery, setSearchQuery] = useState("");

  console.log("ENV", process.env);

  return (
    <>
      <body>
        <div className="d-flex flex-column">
          <div className="forum">
            <FilterProvider>
              <Sidebar setSearchQuery={setSearchQuery} />
              <div className="inner-main">
                <div className="inner-main-body pt-0">
                  <div>
                    <Fade in={content === "PostList"} timeout={300} unmountOnExit>
                      <div>
                        <PostList searchQuery={searchQuery} />
                      </div>
                    </Fade>
                    <Fade in={content === "PostDetails"} timeout={300} unmountOnExit>
                      <div className="post-details">
                        <PostDetails postId={selectedPostId} />
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </FilterProvider>
          </div>
          {process.env.NODE_ENV === "production" && <Footer />}
        </div>
      </body>
    </>
  );
}

export default Forum;
